import type { CreditCardFormAddress } from './credit-card-form-submit';

/** The account fields that carry a billing address (snake_case, as the API returns them). */
export type AccountBillingAddress = {
  address_line1?: string;
  address_line2?: string;
  city?: string;
  state?: string;
  country?: string;
  zip_code?: string;
};

/**
 * Maps an account's saved billing address to the card-form address shape, defaulting missing fields to
 * empty strings. Shared by the checkout flows that prefill the card form / Ordway contact from the
 * account.
 */
export function accountToCreditCardAddress(account: AccountBillingAddress): CreditCardFormAddress {
  return {
    addressLine1: account.address_line1 ?? '',
    addressLine2: account.address_line2 ?? '',
    city: account.city ?? '',
    state: account.state ?? '',
    country: account.country ?? '',
    zipCode: account.zip_code ?? '',
  };
}
